import { Component } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FooterComponent } from './components/footer/footer.component';
import { CommonModule } from '@angular/common';
import { ConstantsService } from './constants/constants.service';
import { filter } from 'rxjs/operators';
import { IdleService } from './services/idle.service';
import { VersionCheckService } from './services/version-check.service';
import { ForceLogoutPopupComponent } from './components/force-logout-popup/force-logout-popup.component';
import { NotificationWebsocketService } from './services/notification-websocket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, SidebarComponent, FooterComponent, CommonModule, ForceLogoutPopupComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'gatehouse-ui';
  showForceLogoutModal = false;
  forceLogoutMessage = '';
  private notifSub: Subscription | null = null;
  constructor(
    private router: Router,
    public constants: ConstantsService,
    private idleService: IdleService,
    private versionCheckService: VersionCheckService,
    private wsService: NotificationWebsocketService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.handleNavigation();
      if (!this.showUserLogin()) {
      this.showForceLogoutModal = false;
      this.forceLogoutMessage = '';
    }
    });
  }
 
  ngOnInit(): void {
    setTimeout(() => this.handleNavigation(), 1000);

    // ✅ Check version periodically
    this.versionCheckService.checkVersion();
    setInterval(() => this.versionCheckService.checkVersion(), 5 * 60 * 1000);
    this.notifSub = this.wsService.getSystemEvents().subscribe((payload: any) => {
    if (payload?.type === 'ROLE_CHANGED' || payload?.type === 'PERMISSION_CHANGED') {
        if (this.showUserLogin()) { 
        this.forceLogoutMessage = payload.message;
        this.showForceLogoutModal = true;
      }
      }
    });
  }
  onForceLogout(): void {
    this.showForceLogoutModal = false;
    this.wsService.disconnect();
    this.constants.clearSession();
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.notifSub?.unsubscribe();
  }
  
  handleNavigation(): void {
    if (this.router.getCurrentNavigation()) {
      return;
    }

    const storage = this.constants.getSession();
    const isMobile = window.innerWidth <= 768;

    if (this.isPublicVisitPage()) {
      return;
    }

    if ((this.router.url === '/' || this.router.url === '') && !storage) {
      if (isMobile) {
        this.router.navigate(['/splash']);
      } else {
        this.router.navigate(['/login']);
      }
    }
  }

  isPublicVisitPage(): boolean {
    return this.router.url.includes('/visit-invite-form/') ||
           this.router.url.includes('/scan-qr-visit-form/') ||
           this.router.url.includes('/visitor-badge/');
  }
 
  showUserLogin() {
    if (this.isPublicVisitPage()) {
      return false;
    }
    
    const storage = this.constants.getSession();
    if (!storage || 
        this.router.url === '/' || 
        this.router.url === '/login' || 
        this.router.url === '/register' || 
        this.router.url === '/forgot-password' || 
        this.router.url === '/splash') {
      return false;
    } else {
      return true;
    }
  }
  
  onMainWrapperClick(event: MouseEvent) {
    const sidebar = document.querySelector('#sidebar');
    const target = event.target as HTMLElement;
 
    if (sidebar && !sidebar.contains(target) && !target.closest('.sidebartoggler')) {
      const wrapper = document.getElementById('main-wrapper');
      if (wrapper) {
        wrapper.classList.remove('show-sidebar');
      }
    }
  }
}